export const checkInviteeWidgetAvailable = (referrerId: number, isConverted: boolean): boolean => (
    Boolean(referrerId && !isConverted)
);
